import React from "react";

interface CloseIconProps {
  size?: number;
}

export const CloseIcon = ({ size = 20 }: CloseIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.99998 11.1668L5.91665 15.2501C5.76387 15.4029 5.56942 15.4793 5.33331 15.4793C5.0972 15.4793 4.90276 15.4029 4.74998 15.2501C4.5972 15.0973 4.52081 14.9029 4.52081 14.6668C4.52081 14.4307 4.5972 14.2362 4.74998 14.0834L8.83331 10.0001L4.74998 5.91677C4.5972 5.76399 4.52081 5.56955 4.52081 5.33344C4.52081 5.09732 4.5972 4.90288 4.74998 4.7501C4.90276 4.59732 5.0972 4.52094 5.33331 4.52094C5.56942 4.52094 5.76387 4.59732 5.91665 4.7501L9.99998 8.83344L14.0833 4.7501C14.2361 4.59732 14.4305 4.52094 14.6666 4.52094C14.9028 4.52094 15.0972 4.59732 15.25 4.7501C15.4028 4.90288 15.4791 5.09732 15.4791 5.33344C15.4791 5.56955 15.4028 5.76399 15.25 5.91677L11.1666 10.0001L15.25 14.0834C15.4028 14.2362 15.4791 14.4307 15.4791 14.6668C15.4791 14.9029 15.4028 15.0973 15.25 15.2501C15.0972 15.4029 14.9028 15.4793 14.6666 15.4793C14.4305 15.4793 14.2361 15.4029 14.0833 15.2501L9.99998 11.1668Z"
        fill="currentColor"
      />
    </svg>
  );
};
